import React from 'react';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import {withStyles} from '@material-ui/core';
import EllipsisWithTooltip from './EllipsisWithTooltip';

class LinkIconButton extends React.Component {
    render() {
        const {text, icon, href, className, classes, target, buttonProps, tooltipProps, iconProps} = this.props;
        return (
            <Button href={href}
                    className={classes[className] || classes.iconButton}
                    size="small"
                    target={target}
                    {...buttonProps}
            >
                {icon && (
                    <Icon className={classes.iconButtonIcon}
                          {...iconProps}
                    >
                        {icon}
                    </Icon>
                )}
                <EllipsisWithTooltip
                    placement="bottom-start"
                    title={text || this.props.children}
                    classes={{tooltip: classes.popper}}
                    tooltipProps={tooltipProps}
                >
                    {this.props.children || text}
                </EllipsisWithTooltip>
            </Button>
        );
    };
}

const styles = theme => ({
    iconButton: {
        fontSize: 14,
        opacity: 0.5,

        display: 'block',

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1,
        },
    },
    iconButtonInline:{
        fontSize: 14,
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1,
        },
    },
    iconButtonIcon: {
        fontSize: 20,
        marginRight: theme.spacing.unit * 2,
        float: 'left',
    },
    popper: {
        fontSize: 14,
        boxShadow: '2px 2px 3px rgba(0,0,0,0.3)',
    },
});

export default withStyles(styles)(LinkIconButton);


